import { amplitudeSource, amplitudeSourceForPots, amplitudeSourceForWallet, } from 'features/invest/utils/analytics';
import { OnboardingFlow } from 'utils/types/navigation';
export const getAmplitudeFlow = (flow) => {
    switch (flow) {
        case OnboardingFlow.Invest:
            return amplitudeSource;
        case OnboardingFlow.Pots:
            return amplitudeSourceForPots;
        case OnboardingFlow.Wallet:
            return amplitudeSourceForWallet;
        default:
            return '';
    }
};
